<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Checkout" mainTitle="Checkout" />
  <CheckoutContent />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import CheckoutContent from "../components/Checkout/CheckoutContent.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "CheckoutPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    CheckoutContent,
    DownloadTheApp,
    MainFooter,
  },
});
</script>